import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { compose, lifecycle, pure } from "recompose";

import CurrencySpan from "../Currency/CurrencySpan";
import { FormattedMessage } from "react-intl";
import Queries from "../../queries/queries2";
import React from "react";
import gql from "graphql-tag";
import { graphql } from "react-apollo";

const toValidateNotifications = (
  <Tooltip id="toCheck">
    <FormattedMessage id="ids_toCheck" />
  </Tooltip>
);
const toQualifyNotifications = (
  <Tooltip id="toQualify">
    <FormattedMessage id="ids_toQualify" />
  </Tooltip>
);
const missingExpenseInvoiceNotifications = (
  <Tooltip id="missingAttachment">
    <FormattedMessage id="ids_missingAttachment" />
  </Tooltip>
);

const BANK_TRANSACTION_CREATED_SUBSCRIPTION = gql`
  subscription onBankTransactionCreated($companyId: ID!, $bankAccountId: ID!) {
    bankTransactionCreated(
      companyId: $companyId
      bankAccountId: $bankAccountId
    ) {
      id
      status
      bankTransactionLines(orderBy: numLine_ASC) {
        id
        category {
          id
        }
        tiers {
          id
        }
      }
      attachment {
        id
      }
      isDeleted
    }
  }
`;

const BANK_TRANSACTION_UPDATED_SUBSCRIPTION = gql`
  subscription onBankTransactionUpdated($companyId: ID!, $bankAccountId: ID!) {
    bankTransactionUpdated(
      companyId: $companyId
      bankAccountId: $bankAccountId
    ) {
      id
      status
      bankTransactionLines(orderBy: numLine_ASC) {
        id
        category {
          id
        }
        tiers {
          id
        }
      }
      attachment {
        id
      }
      isDeleted
    }
  }
`;

const transactionCount = graphql(
  Queries.GET_BANK_ACCOUNT_PENDING_TRANSACTION_COUNT,
  {
    name: "transactionCount",
    options: ({ bankAccount }) => {
      return {
        fetchPolicy: "cache-and-network",
        variables: { bankAccountId: bankAccount.id }
      };
    }
  }
);

const transactionAutoQualifCount = graphql(
  Queries.GET_BANK_ACCOUNT_AUTOQUALIF_TRANSACTION_COUNT,
  {
    name: "transactionAutoQualifCount",
    options: ({ bankAccount }) => {
      return {
        fetchPolicy: "cache-and-network",
        variables: { bankAccountId: bankAccount.id }
      };
    }
  }
);

const transactionMissingExpenseInvoiceCount = graphql(
  Queries.GET_BANK_ACCOUNT_WITHOUT_EXPENSEINVOICE_TRANSACTION_COUNT,
  {
    name: "transactionMissingExpenseInvoiceCount",
    options: ({ bankAccount }) => {
      return {
        fetchPolicy: "cache-and-network",
        variables: { bankAccountId: bankAccount.id }
      };
    }
  }
);

const componentLifecycle = lifecycle({
  componentDidMount() {
    console.log("84 - BankAccountSelectElement.componentDidMount", this);

    if (
      !this.props.transactionCount ||
      !this.props.transactionAutoQualifCount ||
      !this.props.transactionMissingExpenseInvoiceCount
    )
      return;

    if (this.unsubscribeBankTransactionCreated)
      this.unsubscribeBankTransactionCreated();

    // BankTransactionCreated
    //if (!!!this.unsubscribeBankTransactionCreated)
    this.unsubscribeBankTransactionCreated = this.props.transactionCount.subscribeToMore(
      {
        document: BANK_TRANSACTION_CREATED_SUBSCRIPTION,
        variables: {
          companyId: this.props.companyId,
          bankAccountId: this.props.bankAccount.id
        },

        updateQuery: (prev, { subscriptionData }) => {
          if (!prev.bankAccount || !prev._bankTransactionsMeta) {
            // console.log("refecth...");
            this.props.transactionCount.refetch();
            this.props.transactionAutoQualifCount.refetch();
            this.props.transactionMissingExpenseInvoiceCount.refetch();
          }
          return prev;
        }
      }
    );

    if (this.unsubscribeBankTransactionUpdated)
      this.unsubscribeBankTransactionUpdated();

    // BankTransactionUpdated
    // if (!!!this.unsubscribeBankTransactionUpdated)
    this.unsubscribeBankTransactionUpdated = this.props.transactionCount.subscribeToMore(
      {
        document: BANK_TRANSACTION_UPDATED_SUBSCRIPTION,
        variables: {
          companyId: this.props.companyId,
          bankAccountId: this.props.bankAccount.id
        },

        updateQuery: (prev, { subscriptionData }) => {
          if (!prev.bankAccount || !prev._bankTransactionsMeta) {
            // console.log("refecth...");
            this.props.transactionCount.refetch();
            this.props.transactionAutoQualifCount.refetch();
            this.props.transactionMissingExpenseInvoiceCount.refetch();
          }
          return prev;
        }
      }
    );
    return;
  },

  componentWillUnmount() {
    if (this.unsubscribeBankTransactionCreated)
      this.unsubscribeBankTransactionCreated();

    if (this.unsubscribeBankTransactionUpdated)
      this.unsubscribeBankTransactionUpdated();
  }
});

const CustomTooltip = props => {
  if (!props.tooltip) {
    return <div>{props.children}</div>;
  }
  return (
    <OverlayTrigger
      key={"top"}
      placement={"top"}
      overlay={
        <Tooltip id={`tooltip-top`}>
          <strong>{props.tooltip}</strong>.
        </Tooltip>
      }>
      {props.children}
    </OverlayTrigger>
  );
};

const BankAccountSelectElement = ({
  bankAccount,
  transactionCount,
  transactionAutoQualifCount,
  transactionMissingExpenseInvoiceCount,
  intl
}) => {
  const errorMessage =
    bankAccount.providerAccount && bankAccount.providerAccount.error;

  const translatedErrorMessage = errorMessage
    ? // budgea error message list :
    // wrongpass The authentication on website has failed
    // additionalInformationNeeded Additional information is needed such as an OTP
    // websiteUnavailable The website is unavailable, for instance we get a HTTP 503 response when requesting the website
    // actionNeeded An action is needed on the website by the user, scraping is blocked
    // bug A bug has occurred during the synchronization.An alert has been sent to Budget Insight
    // will be transforme to ids_<msg>

    intl.formatMessage({ id: `ids_budgea_${errorMessage}` })
    : "";

  // let textDecoration =
  //   (bankAccount && bankAccount.dateCloture)
  //       ? "line-through"
  //       : "Inherit";

  let textColor =
    bankAccount && bankAccount.dateCloture ? "LightGrey" : "Inherit";

  // let warningColor =
  //   bankAccount && bankAccount.dateCloture ? "LightGrey" : "#FFA534";
  let errorColor =
    bankAccount && bankAccount.dateCloture ? "LightGrey" : "#FB404B";
  let successColor =
    bankAccount && bankAccount.dateCloture ? "LightGrey" : "#1AA29A";

  // ---> style= {{textDecoration: textDecoration, color: textColor}}>

  return (
    <div
      className="bank-account-select-element space-between" //>
      style={{ color: textColor }}>
      {translatedErrorMessage && (
        <CustomTooltip tooltip={translatedErrorMessage}>
          <div className="fa fa-warning " style={{ color: errorColor }} />
        </CustomTooltip>
      )}

      {!!!translatedErrorMessage && bankAccount && !!bankAccount.importedAccount && (
        <div>
          <CustomTooltip tooltip={translatedErrorMessage}>
            <div className="fa fa-file-excel-o" style={{ color: "green" }} />
          </CustomTooltip>
        </div>
      )}

      {!!!translatedErrorMessage && bankAccount && !!bankAccount.syncAccount && !!!bankAccount.importedAccount && (
        <div>
          <CustomTooltip tooltip={translatedErrorMessage}>
            <div className="fa fa-check " style={{ color: successColor }} />
          </CustomTooltip>
        </div>
      )}

      {!!!translatedErrorMessage && bankAccount && !!!bankAccount.syncAccount && !!!bankAccount.importedAccount && (
        <CustomTooltip
          tooltip={intl.formatMessage({ id: "ids_unsynchronizedAccount" })}>
          <div className="fa fa-unlink " style={{ color: textColor }} />
        </CustomTooltip>
      )}

      <div
        className="space-between align-items-center "
        style={{ width: "96%" }}>
        {bankAccount.name ? bankAccount.name : bankAccount.originalName}
        <CurrencySpan
          currencyId={
            (bankAccount && bankAccount.currency && bankAccount.currency.id) ||
            "cjcg3nnrfp2z00125ckh0ejen" // ???????
          }
          value={bankAccount.solde}
        />
        <span className="pull-right">
          {transactionAutoQualifCount._bankTransactionsMeta &&
            transactionAutoQualifCount._bankTransactionsMeta.count > 0 && (
              <OverlayTrigger placement="top" overlay={toValidateNotifications}>
                <span className="badge" style={{ background: "Green" }}>
                  {transactionAutoQualifCount._bankTransactionsMeta &&
                    transactionAutoQualifCount._bankTransactionsMeta.count}
                </span>
              </OverlayTrigger>
            )}
          {transactionCount._bankTransactionsMeta &&
            transactionCount._bankTransactionsMeta.count > 0 && (
              <OverlayTrigger placement="top" overlay={toQualifyNotifications}>
                <span className="badge" style={{ background: "Red" }}>
                  {transactionCount._bankTransactionsMeta &&
                    transactionCount._bankTransactionsMeta.count}
                </span>
              </OverlayTrigger>
            )}

          {transactionMissingExpenseInvoiceCount._bankTransactionsMeta &&
            transactionMissingExpenseInvoiceCount._bankTransactionsMeta.count > 0 && (
              <OverlayTrigger placement="top" overlay={missingExpenseInvoiceNotifications}>
                <span className="badge" style={{ background: "Red" }}>
                  {transactionMissingExpenseInvoiceCount._bankTransactionsMeta &&
                    transactionMissingExpenseInvoiceCount._bankTransactionsMeta.count}
                </span>
              </OverlayTrigger>
            )}
        </span>
      </div>
    </div>
  );
};

export default compose(
  transactionCount,
  transactionAutoQualifCount,
  transactionMissingExpenseInvoiceCount,
  componentLifecycle,
  pure
)(BankAccountSelectElement);
